/* MAIDE APPAREL — Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  // Cart Drawer
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');
  document.querySelectorAll('[data-cart-open]').forEach(function(el) {
    el.addEventListener('click', function() {
      cartDrawer && cartDrawer.classList.add('open');
      cartOverlay && cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  });
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // Mobile Menu
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  mobileToggle && mobileToggle.addEventListener('click', function() {
    mobileNav && mobileNav.classList.toggle('open');
    this.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
  });

  // FAQ Accordion
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const answer = this.nextElementSibling;
      const isOpen = this.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-question').forEach(function(b) {
        b.classList.remove('open');
        b.nextElementSibling && b.nextElementSibling.classList.remove('open');
      });
      if (!isOpen) {
        this.classList.add('open');
        answer && answer.classList.add('open');
      }
    });
  });

  // Product Gallery Thumbnails
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.getElementById('main-product-img');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImg) mainImg.src = this.querySelector('img').src;
    });
  });

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 8 ? '0 2px 16px rgba(17,17,17,0.07)' : 'none';
    });
  }

  // Variant selection on product page
  const variantDataEl = document.getElementById('variant-data');
  if (variantDataEl) {
    const variants = JSON.parse(variantDataEl.textContent);
    const selectedOpts = {};
    document.querySelectorAll('[data-opt]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const pos = this.dataset.opt;
        const val = this.dataset.val;
        selectedOpts[pos] = val;
        document.querySelectorAll('[data-opt="' + pos + '"]').forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        const match = variants.find(function(v) {
          return Object.keys(selectedOpts).every(function(p) { return v['option' + p] === selectedOpts[p]; });
        });
        if (match) {
          const idInput = document.getElementById('variant-id');
          const addBtn = document.querySelector('.add-to-cart');
          if (idInput) idInput.value = match.id;
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
          }
        }
      });
    });
  }

  // Smooth scroll anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

});
